import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Container, Row, Col, Spacer } from '@cleartrip/bento/lib';
import LogoList from '../../../components/LogoList';
import Sandbox from '@components/Sandbox';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h1 {...{
      "id": "brand-icons-and-logos"
    }}>{`Brand Icons and Logos`}</h1>
    <p>{`Click the Icon to copy Icon name`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <Sandbox mdxType="Sandbox">
  <Sandbox.Text>
    import {'{ LogoName }'} from '@cleartrip/bento-icons'
  </Sandbox.Text>
    </Sandbox>
    <h2 {...{
      "id": "explore-logos"
    }}>{`Explore logos`}</h2>
    <LogoList mdxType="LogoList" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      